import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgInstantConfirmCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx={8} cy={8} r={8} fill="#007AFF" />
      <path
        fill="#FFF"
        d="M9.597 3.5 5.48 9.053l1.46.087-.579 4.064L10.4 7.322 9.066 7.23z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgInstantConfirmCircle);
export default Memo;
